class clearFilter extends HTMLElement {
    constructor() {
        super();

        this.mainBlogHeader = document.querySelector("[js-main-blog-header]");
        this.mainBlog = document.querySelector("[js-hb-main-blog]");
        this.tagUrl = this.dataset.tagUrl;

        this.init();
    };
    getSectionsToRender() {
        return [
            {
                selector: "js-main-blog-header",
                sectionId: this.mainBlogHeader?.dataset?.section || "Header not found"
            },
            {
                selector: "js-hb-main-blog",
                sectionId: this.mainBlog?.dataset?.section || "Main blog not found"
            },
        ];
    }
    init() {
        this.addEventListener('click', (e) => {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent("changeState", {
                detail: {
                    target: this.filterItem
                }
            }));
            document.dispatchEvent(new CustomEvent("updateHistoryState", {
                detail: {
                    url: this.tagUrl
                }
            }));
            this.renderAjaxBlog(this.tagUrl);
        })
    };
   
    renderAjaxBlog(tagUrl) {  
        this.getSectionsToRender().forEach(section => {
            const url = `${tagUrl}?section_id=${section.sectionId}`;
           
            fetch(url).then(function(response) {
                return response.text();
                }).then((html) => {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    const newContent = doc.querySelector(`[${section.selector}]`);
                    if (newContent) {
                        const filterDrawer = newContent.querySelector('[js-blog-filter-drawer]');
                        if (filterDrawer) {
                            filterDrawer.classList.add('open');
                        }
                        if (section.selector === "js-main-blog-header" && this.mainBlogHeader) {
                            this.mainBlogHeader.innerHTML = newContent.innerHTML;
                        } else if (section.selector === "js-hb-main-blog" && this.mainBlog) {
                            this.mainBlog.innerHTML = newContent.innerHTML;
                        }
                    }
                    document.dispatchEvent(new CustomEvent("filter-drawer:init"));
                });
            });
    }
}
    
customElements.define('clear-filter', clearFilter);